import { useEffect, useState } from 'react'
import { PageHeader, TabsComponent, CardComponent } from '@/components/molecules'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { SalesTargetList, SalesTargetsActivitiesList } from '@/containers'
import { HeaderTitle } from '@/components/atoms'
import { Header } from '@/utils/constants/header'
import { useSalesTargets } from '@/hooks/useSalesTargets'
import { useActivites } from '@/containers/Activity/useActivites'
import { resetSalesTarget } from '@/store/slices/salesTargetSlice'
import { useDispatch } from 'react-redux'
import { resetActivityData } from '@/store/slices/activitySlice'
import { useAppSelector } from '@/store'

export const SalesTargetHome = ({ instanceKey, selectedTab }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  let tab = params.get('tab') ? parseInt(params.get('tab')) : 0
  const { activityListData } = useActivites()
  const { salesTargetsData } = useSalesTargets()
  const [isLoading, setIsLoading] = useState(true)
  const countryCode = useAppSelector(state => state.countryCode).countryCode

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false)
    }, 3000)
    if (salesTargetsData?.data) {
      setIsLoading(false)
      clearTimeout(timeout)
    }
    return () => clearTimeout(timeout)
  }, [salesTargetsData?.data])
  const handleNavigateToSalesTargetAdd = () => {
    dispatch(resetSalesTarget())
    navigate(ROUTES.SALES_TARGET_ADD)
  }
  const handleNavigateToActivityAdd = () => {
    dispatch(resetActivityData({}))
    navigate(ROUTES.ACTIVITY_ADD)
  }
  const cardList = [
      {
        centralIcon: 'local_police',
        ctaPrimary: {
          text: 'Add Activity',
          onClick: () => handleNavigateToActivityAdd(),
        },
        title: `${activityListData?.activeCount ?? ''} Activities are active`,
      },
      {
        centralIcon: 'location_searching',
        ctaPrimary: { text: 'Add Sales Target', onClick: () =>
          handleNavigateToSalesTargetAdd()
        },
        title: `${salesTargetsData?.activeCount} Sales Targets are active`,
      },
      // {
      //   centralIcon: 'list_alt',
      //   ctaPrimary: {
      //     text: 'Add NBA',
      //     onClick: () => alert('NBA is part of other module.'),
      //   },
      //   title: '12 NBA Items',
      // },
    ];

  const tabList = [
    { id: 'activities', tabLabel: 'Activities', title: 'Activity List', tabComponent: <SalesTargetsActivitiesList /> },
    { id: 'sales-target', tabLabel: 'Sales Target', title: 'Sales Target Table', tabComponent: <SalesTargetList /> },
    // {
    //   id: 'nba',
    //   tabLabel: 'NBA',
    //   title: 'NBA List',
    //   tabComponent: <div>NBA Data</div>,
    // },
  ]

  if (selectedTab) {
    tab = tabList.findIndex(tab => tab.id === selectedTab);
  }

  const defaultTitle = tabList[tab]?.title || ''
  const [title, setTitle] = useState(defaultTitle)

  const getSelectedTabIndex = i => {
    const tabObj = tabList[i]
    setTitle(tabObj?.title)
    if (tabObj?.id === 'activities') {
      navigate(ROUTES.ACTIVITIES)
    } else if (tabObj?.id === 'sales-target') {
      navigate(ROUTES.SALES_TARGETS)
    }
  }

  return (
    <div key={instanceKey+countryCode} className="salesTargetsContainer flex flex-col">
      <PageHeader title="Loyalty Campaigns" />
      <div className="targetCardComponent mb-5">
        <CardComponent cardList={cardList} isLoading={isLoading} />
      </div>
      <div style={{ backgroundColor: '#1D1D1D', paddingLeft: '16px' }} className="salesTargetsTitleSection relative">
        <HeaderTitle headingLevel={Header.SectionTitle} title={title} className="salesTargetsDataTableHeading" />
      </div>
      <div
        style={{ backgroundColor: '#1D1D1D', paddingLeft: '16px' }}>
        <TabsComponent tabList={tabList} defaultTabIndex={tab} onTabChange={getSelectedTabIndex} />
      </div>
    </div>
  )
}
